module.exports = __webpack_public_path__ + "img/smartTV.f4c04764.svg";